import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import {
  Header,
  HeroSection,
  ProblemSection,
  ProcessSection,
  ResultsSection,
  PhilosophySection,
  AboutSection,
  TestimonialsSection,
  CoachingProgramsSection,
  Footer
} from "./components";
import {
  FreeAssessmentPage,
  WorkshopsPage,
  PodcastPage,
  ResourcesPage,
  AboutPage,
  WorkshopBookingPage,
  ProcessDetailsPage,
  FestivalPage,
  WaitWithMePage,
  SupportBritishTheatrePage,
  FAQsPage,
  TestimonialsPage,
  TermsPage,
  PrivacyPage
} from "./pages";
import BusinessPlaywrightHome from "./business-playwright/BusinessPlaywrightHome";
import TheTakeoverPage from "./business-playwright/takeover/TheTakeoverPage";
import BlindFaithPage from "./business-playwright/blind-faith/BlindFaithPage";
import AdminPage from "./business-playwright/admin/AdminPage";
import PutYourStoryOnStagePage from "./business-playwright/story/PutYourStoryOnStagePage";
import BusinessPlaywrightAbout from "./business-playwright/about/AboutPage";
import HowToTurnYourPhoneOffPage from "./business-playwright/phone/HowToTurnYourPhoneOffPage";
import NotFoundPage from "./business-playwright/NotFoundPage";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <ProblemSection />
      <ProcessSection />
      <ResultsSection />
      <PhilosophySection />
      <TestimonialsSection />
      <CoachingProgramsSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BusinessPlaywrightHome />} />
          <Route path="/the-takeover" element={<TheTakeoverPage />} />
          <Route path="/blind-faith" element={<BlindFaithPage />} />
          <Route path="/how-to-turn-your-phone-off" element={<HowToTurnYourPhoneOffPage />} />
          <Route path="/put-your-story-on-stage" element={<PutYourStoryOnStagePage />} />
          <Route path="/about" element={<BusinessPlaywrightAbout />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/flow" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          <Route path="/free-assessment" element={<FreeAssessmentPage />} />
          <Route path="/workshops" element={<WorkshopsPage />} />
          <Route path="/workshop-booking" element={<WorkshopBookingPage />} />
          <Route path="/process-details" element={<ProcessDetailsPage />} />
          <Route path="/festival" element={<FestivalPage />} />
          <Route path="/wait-with-me" element={<WaitWithMePage />} />
          <Route path="/support-british-theatre" element={<SupportBritishTheatrePage />} />
          <Route path="/podcast" element={<PodcastPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/flow/about" element={<AboutPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;